const doc = [({"ja":({"adminCancelPolicyOption":({"original":"キャンセルポリシーを適用する", "free":"キャンセル料を無料にする", "fixedFee":"下記のキャンセル料を適用する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;